export enum SignalREvents {
  TenantSubscription = 'TenantSubscription',
  ContactVerification = 'ContactVerificationPassed',
  MessageChannelSms = 'MessagingSmsToChannel',
  MessagingWhatsAppToChannel = 'MessagingWhatsAppToChannel',
  PsaTechVerification = 'PsaTechVerificationSmsRequest',
  TeamsChatMessage = 'TeamsChatMessage',
}
